export default __webpack_public_path__ + "static/media/info-square.e1f55f32.svg";